import { Component, ViewChild } from '@angular/core';
import { ActiveEmployeeModel, AppTableComponent,  MessagesComponent, SearchModel, SearchResultModel, TaskModel, TaskService, TranslationManager, UsersService } from 'src/common';


@Component({
  selector: 'task-select',
  templateUrl: 'task-select.component.html'
})

export class TaskSelectComponent {
  constructor(private taskService: TaskService) { }

  @ViewChild('table') table: AppTableComponent;
  translationManager = TranslationManager;
  selectedId: number;
  items: any[];
  show: boolean = false;
  resolve: any;

  requestId:number;
  cond:string;

  showModal(requestId:number=null) : Promise<TaskModel> {
      this.show = true;

      this.requestId=requestId;

      this.table.onSearch = this.doSearch.bind(this);
      this.table.search();

      return new Promise((resolve) => {
          this.resolve = resolve;
      })
  }

  doSearch(search: SearchModel) {
      this.taskService.searchSelectOpnProjectDeadlinesList(search,this.requestId).then((result: SearchResultModel<TaskModel>) => {
        this.items = result.items;
        this.table.setTotalCount(result.totalCount);
    });
  }

  selectTask(id: number,event) {
      if (event.target.checked) {
        this.selectedId = id;
      }
      else {
        this.selectedId = undefined;
      }
  }

  close() {
      this.show = false;
      if (this.resolve) {
          this.resolve();
      }
  }

  submit() {
    if (this.selectedId == undefined) {
      MessagesComponent.instance.showError([this.translationManager.getTranslation('Морате изабрати задатак')]);
    }
    else {
      this.save();
    }
  }

  save() {

      this.show = false;
      if (this.resolve) {
          let model: TaskModel = this.items.find((x => x.id == this.selectedId));
          this.resolve(model);
      }
  }
}
